import React from 'react'

import UnitVocabularySkeleton from 'src/pages/UnitVocabulary/UnitVocabularySkeleton'
import VocabularyWordListPlaceholder from 'src/ui/VocabularyWordList/VocabularyWordListPlaceholder'

import VocabularyHeaderPlaceholder from './subcomponents/VocabularyHeader/VocabularyHeaderPlaceholder'

const UnitVocabularyPlaceholder = () => {
  return (
    <UnitVocabularySkeleton
      headerSection={<VocabularyHeaderPlaceholder />}
      listSection={<VocabularyWordListPlaceholder />}
    />
  )
}

export default UnitVocabularyPlaceholder
